export default {
    zh: {
        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI视频生成器 - 音画同步生成 | WeryAI',
        pageDescription: 'Kling 2.6 Pro 是快手旗下革命性AI视频生成模型，首创音画同步生成能力，支持1080p高清视频、中英双语语音、角色一致性控制。在WeryAI免费体验Kling 2.6 Pro。',
        pageKeywords: 'Kling 2.6 Pro, AI视频生成, 音画同步, 快手AI, 视频生成器, AI配音, 1080p视频, WeryAI',

        // 生成器部分
        generatorTitle: 'Kling 2.6 Pro 视频生成器',
        generatorDescription: 'WeryAI 现已深度集成Kling 2.6 Pro模型，Kling 2.6 Pro 是快手（Kuaishou）旗下 Kling AI 推出的一款革命性全能 AI 视频生成模型。作为 2.6 版本的专业旗舰款，它不仅继承了前代卓越的画质，更首创了"音画同步生成"能力，能在生成 1080p 高清视频的同时，自动合成精确匹配的对话、音效和环境音。这一突破性技术让创作者无需后期配音即可获得完整的视听作品，极大地提升了从创意到成片的效率。快来 WeryAI 免费体验 Kling 2.6 Pro 的影音同步魔法吧！',

        // 标签页
        tabImageToVideo: '图片生成视频',
        tabTextToVideo: '文本生成视频',

        // 核心功能部分
        coreFeaturesTitle: 'Kling 2.6 Pro 核心功能特性',

        // 功能特点
        feature1Title: '原生音画同步生成',
        feature1Description: 'Kling 2.6 Pro 打破了视频与音频分离生成的传统界限。它能根据画面内容，在一次推理中同时生成与动作精准对位的音效（如脚步声、碰撞声）以及自然的人声对话，确保"所见即所听"。',
        feature2Title: '中英双语语音支持',
        feature2Description: '模型内置了高质量的中英文语音引擎。用户只需在提示词中指定台词，即可生成口型对得上的角色对话，支持多种情感语调，非常适合制作叙事短片或营销广告。',
        feature3Title: '1080p 电影级画质与光影',
        feature3Description: '输出分辨率默认为 1080p，具备极高的视觉保真度。模型对光影反射、材质纹理（如皮肤、金属、水面）的理解达到了新的高度，画面细腻无噪点。',
        feature4Title: 'Elements 角色一致性控制',
        feature4Description: '通过"Elements"功能，用户可以上传参考图像来固定视频中的主角形象。即使在复杂的运镜或长镜头中，角色的面部特征和服装细节也能保持高度一致，不再"变脸"。',
        feature5Title: '长视频延伸与连贯性',
        feature5Description: '支持基础 10 秒生成，并可通过"Extend"功能多次延展视频时长（最高支持数分钟），同时保持动作的流畅性和逻辑的连贯性，适合制作长镜头叙事内容。',

        // 如何使用部分
        howToUseTitle: '如何在 WeryAI 上使用 Kling 2.6 Pro',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Kling 2.6 Pro 模型',
        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',
        step3Title: '生成视频',
        step3Description: '点击生成按钮，等待并下载您的视频',

        // YouTube 视频部分
        youtubeTitle: '关于 Kling 2.6 Pro 的精彩视频介绍',

        // X Posts 部分
        xPostsTitle: '关于 Kling 2.6 Pro 的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索 WeryAI 上的其他工具',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma 梦想机器',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ 部分
        faqTitle: '常见问题',

        // CTA 部分
        ctaTitle: '立即体验 Kling 2.6 Pro',
        ctaDescription: '在 WeryAI 上免费开始创作音画同步的 AI 视频',
        ctaButton: '开始生成视频',
        ctaDisclaimer: '无需信用卡，注册即可使用',
    },
    en: {
        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI Video Generator - Audio-Visual Synchronization | WeryAI',
        pageDescription: 'Kling 2.6 Pro is Kuaishou\'s revolutionary AI video generation model, pioneering audio-visual synchronization generation, supporting 1080p HD video, bilingual voice (Chinese/English), and character consistency control. Experience Kling 2.6 Pro for free on WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, AI video generation, audio-visual sync, Kuaishou AI, video generator, AI voiceover, 1080p video, WeryAI',

        // Generator section
        generatorTitle: 'Kling 2.6 Pro Video Generator',
        generatorDescription: 'WeryAI now deeply integrates the Kling 2.6 Pro model, Kling 2.6 Pro is a revolutionary all-in-one AI video generation model launched by Kling AI under Kuaishou. As the professional flagship of version 2.6, it not only inherits the excellent image quality of previous generations but also pioneers "audio-visual synchronization generation" capability, automatically synthesizing precisely matched dialogue, sound effects, and ambient sounds while generating 1080p HD video. This breakthrough technology allows creators to obtain complete audiovisual works without post-production dubbing, greatly improving efficiency from concept to finished product. Come experience the magic of Kling 2.6 Pro\'s audio-visual synchronization on WeryAI for free!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling 2.6 Pro Core Features',

        // Features
        feature1Title: 'Native Audio-Visual Synchronization',
        feature1Description: 'Kling 2.6 Pro breaks the traditional boundary of separate video and audio generation. It can simultaneously generate precisely synchronized sound effects (such as footsteps, collision sounds) and natural human dialogue in a single inference based on the visual content, ensuring "what you see is what you hear".',
        feature2Title: 'Bilingual Voice Support (Chinese/English)',
        feature2Description: 'The model has built-in high-quality Chinese and English voice engines. Users only need to specify dialogue in the prompt to generate character conversations with synchronized lip movements, supporting various emotional tones, perfect for creating narrative short films or marketing advertisements.',
        feature3Title: '1080p Cinematic Quality & Lighting',
        feature3Description: 'Output resolution defaults to 1080p with extremely high visual fidelity. The model\'s understanding of light reflection, material textures (such as skin, metal, water surfaces) has reached new heights, with fine details and no noise.',
        feature4Title: 'Elements Character Consistency Control',
        feature4Description: 'Through the "Elements" feature, users can upload reference images to fix the main character\'s appearance in the video. Even in complex camera movements or long shots, the character\'s facial features and clothing details remain highly consistent, no more "face swapping".',
        feature5Title: 'Long Video Extension & Coherence',
        feature5Description: 'Supports basic 10-second generation, and can extend video duration multiple times through the "Extend" feature (up to several minutes), while maintaining smooth motion and logical coherence, suitable for creating long-shot narrative content.',

        // How to use section
        howToUseTitle: 'How to Use Kling 2.6 Pro on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling 2.6 Pro model in the AI video tools.',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload a reference image.',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling 2.6 Pro',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Kling 2.6 Pro',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Tools on WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling 2.6 Pro Now',
        ctaDescription: 'Start creating audio-visual synchronized AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',
    },
    ja: {
        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI動画生成器 - 音画同期生成 | WeryAI',
        pageDescription: 'Kling 2.6 Proは快手（Kuaishou）の革新的なAI動画生成モデルで、音画同期生成を初めて実現し、1080p高画質動画、中英バイリンガル音声、キャラクター一貫性制御をサポート。WeryAIでKling 2.6 Proを無料体験。',
        pageKeywords: 'Kling 2.6 Pro, AI動画生成, 音画同期, 快手AI, 動画生成器, AI音声, 1080p動画, WeryAI',

        // Generator section
        generatorTitle: 'Kling 2.6 Pro 動画生成器',
        generatorDescription: 'WeryAI はKling 2.6 Proモデルを深く統合し、Kling 2.6 Proは、快手（Kuaishou）傘下のKling AIが開発した革新的なオールインワンAI動画生成モデルです。バージョン2.6のプロフェッショナルフラグシップとして、前世代の優れた画質を継承するだけでなく、「音画同期生成」機能を初めて実現し、1080p高画質動画を生成しながら、正確にマッチした対話、音響効果、環境音を自動合成します。この画期的な技術により、クリエイターは後付けの音声合成なしで完全な視聴覚作品を獲得でき、アイデアから完成品までの効率を大幅に向上させます。WeryAIでKling 2.6 Proの音画同期の魔法を無料で体験してください！',

        // Tabs
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // Core features section
        coreFeaturesTitle: 'Kling 2.6 Pro コア機能',

        // Features
        feature1Title: 'ネイティブ音画同期生成',
        feature1Description: 'Kling 2.6 Proは、動画と音声を分離して生成する従来の境界を打破しました。画面内容に基づいて、1回の推論で、動作と正確に同期した音響効果（足音、衝突音など）と自然な人間の対話を同時に生成し、「見たままが聞こえる」ことを保証します。',
        feature2Title: '中英バイリンガル音声サポート',
        feature2Description: 'モデルには高品質な中国語と英語の音声エンジンが内蔵されています。ユーザーはプロンプトで台詞を指定するだけで、口の動きと一致したキャラクターの対話を生成でき、様々な感情のトーンをサポートし、ナラティブ短編やマーケティング広告の制作に最適です。',
        feature3Title: '1080p映画級画質と光の表現',
        feature3Description: '出力解像度はデフォルトで1080pで、非常に高い視覚的忠実度を備えています。モデルは光の反射、材質の質感（肌、金属、水面など）の理解が新たな高みに達し、細部まで繊細でノイズのない画面を実現します。',
        feature4Title: 'Elementsキャラクター一貫性制御',
        feature4Description: '「Elements」機能により、ユーザーは参照画像をアップロードして動画内の主人公の外見を固定できます。複雑なカメラワークやロングショットでも、キャラクターの顔の特徴や服装の細部が高度に一貫して保たれ、「顔の入れ替え」は発生しません。',
        feature5Title: '長編動画延長と一貫性',
        feature5Description: '基本的な10秒生成をサポートし、「Extend」機能で動画の長さを複数回延長できます（最大数分まで）、動作の滑らかさと論理的一貫性を保ちながら、ロングショットナラティブコンテンツの制作に適しています。',

        // How to use section
        howToUseTitle: 'WeryAIでKling 2.6 Proを使用する方法',
        step1Title: 'モデルを選択',
        step1Description: 'AI動画ツールでKling 2.6 Proモデルを選択します。',
        step2Title: '内容を入力',
        step2Description: 'プロンプトを入力するか、参照画像をアップロードします。',
        step3Title: '動画を生成',
        step3Description: '生成ボタンをクリックし、待機して動画をダウンロードします。',

        // YouTube videos section
        youtubeTitle: 'Kling 2.6 Proに関する素晴らしい動画紹介',

        // X Posts section
        xPostsTitle: 'Kling 2.6 Proに関する人気のXポスト',

        // Explore other models section
        exploreModelsTitle: 'WeryAI上の他のツールを探索',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ section
        faqTitle: 'よくある質問',

        // CTA section
        ctaTitle: '今すぐKling 2.6 Proを体験',
        ctaDescription: 'WeryAIで音画同期のAI動画を無料で作成開始',
        ctaButton: '動画生成を開始',
        ctaDisclaimer: 'クレジットカード不要、登録して使用',
    },
    ko: {
        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI 동영상 생성기 - 음화 동기화 생성 | WeryAI',
        pageDescription: 'Kling 2.6 Pro는 쿠아이쇼우(Kuaishou)의 혁신적인 AI 동영상 생성 모델로, 음화 동기화 생성을 최초로 구현하며 1080p 고화질 동영상, 중영 이중 언어 음성, 캐릭터 일관성 제어를 지원합니다. WeryAI에서 Kling 2.6 Pro를 무료로 체험하세요.',
        pageKeywords: 'Kling 2.6 Pro, AI 동영상 생성, 음화 동기화, 쿠아이쇼우 AI, 동영상 생성기, AI 음성, 1080p 동영상, WeryAI',

        // Generator section
        generatorTitle: 'Kling 2.6 Pro 동영상 생성기',
        generatorDescription: 'WeryAI는 이제 Kling 2.6 Pro 모델을 심층 통합하여, Kling 2.6 Pro는 쿠아이쇼우(Kuaishou) 산하 Kling AI가 개발한 혁신적인 올인원 AI 동영상 생성 모델입니다. 버전 2.6의 프로페셔널 플래그십으로, 전 세대의 우수한 화질을 계승할 뿐만 아니라 "음화 동기화 생성" 기능을 최초로 구현하여 1080p 고화질 동영상을 생성하면서 정확하게 일치하는 대화, 음향 효과, 환경음을 자동으로 합성합니다. 이 획기적인 기술로 제작자는 후반 작업 음성 합성 없이 완전한 시청각 작품을 얻을 수 있으며, 아이디어에서 완성품까지의 효율을 크게 향상시킵니다. WeryAI에서 Kling 2.6 Pro의 음화 동기화 마법을 무료로 체험해보세요!',

        // Tabs
        tabImageToVideo: '이미지에서 동영상',
        tabTextToVideo: '텍스트에서 동영상',

        // Core features section
        coreFeaturesTitle: 'Kling 2.6 Pro 핵심 기능',

        // Features
        feature1Title: '네이티브 음화 동기화 생성',
        feature1Description: 'Kling 2.6 Pro는 동영상과 오디오를 분리하여 생성하는 전통적인 경계를 깨뜨렸습니다. 화면 내용에 따라 한 번의 추론에서 동작과 정확하게 동기화된 음향 효과(발소리, 충돌음 등)와 자연스러운 인간 대화를 동시에 생성하여 "보는 것이 듣는 것"을 보장합니다.',
        feature2Title: '중영 이중 언어 음성 지원',
        feature2Description: '모델에는 고품질 중국어 및 영어 음성 엔진이 내장되어 있습니다. 사용자는 프롬프트에서 대사만 지정하면 입 모양이 일치하는 캐릭터 대화를 생성할 수 있으며, 다양한 감정 톤을 지원하여 내러티브 단편 영화나 마케팅 광고 제작에 완벽합니다.',
        feature3Title: '1080p 영화급 화질과 조명',
        feature3Description: '출력 해상도는 기본적으로 1080p이며 매우 높은 시각적 충실도를 갖추고 있습니다. 모델의 빛 반사, 재질 질감(피부, 금속, 수면 등)에 대한 이해가 새로운 높이에 도달했으며, 세밀한 디테일과 노이즈 없는 화면을 구현합니다。',
        feature4Title: 'Elements 캐릭터 일관성 제어',
        feature4Description: '"Elements" 기능을 통해 사용자는 참조 이미지를 업로드하여 동영상의 주인공 외모를 고정할 수 있습니다. 복잡한 카메라 워크나 롱 샷에서도 캐릭터의 얼굴 특징과 의상 세부 사항이 높은 일관성을 유지하며 "얼굴 교체"가 발생하지 않습니다.',
        feature5Title: '장편 동영상 연장 및 일관성',
        feature5Description: '기본 10초 생성을 지원하며 "Extend" 기능을 통해 동영상 길이를 여러 번 연장할 수 있습니다(최대 수분까지), 동작의 부드러움과 논리적 일관성을 유지하면서 롱 샷 내러티브 콘텐츠 제작에 적합합니다.',

        // How to use section
        howToUseTitle: 'WeryAI에서 Kling 2.6 Pro 사용 방법',
        step1Title: '모델 선택',
        step1Description: 'AI 동영상 도구에서 Kling 2.6 Pro 모델을 선택합니다.',
        step2Title: '내용 입력',
        step2Description: '프롬프트를 입력하거나 참조 이미지를 업로드합니다.',
        step3Title: '동영상 생성',
        step3Description: '생성 버튼을 클릭하고 기다린 후 동영상을 다운로드합니다.',

        // YouTube videos section
        youtubeTitle: 'Kling 2.6 Pro에 대한 흥미진진한 동영상 소개',

        // X Posts section
        xPostsTitle: 'Kling 2.6 Pro에 대한 인기 X 게시물',

        // Explore other models section
        exploreModelsTitle: 'WeryAI의 다른 도구 탐색',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ section
        faqTitle: '자주 묻는 질문',

        // CTA section
        ctaTitle: '지금 Kling 2.6 Pro 체험하기',
        ctaDescription: 'WeryAI에서 음화 동기화 AI 동영상을 무료로 제작 시작',
        ctaButton: '동영상 생성 시작',
        ctaDisclaimer: '신용카드 불필요, 등록하여 사용',
    },
    tw: {

        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI视频生成器 - 音画同步生成 | WeryAI',
        pageDescription: 'Kling 2.6 Pro 是快手旗下革命性AI视频生成模型，首创音画同步生成能力，支持1080p高清视频、中英双语语音、角色一致性控制。在WeryAI免费体验Kling 2.6 Pro。',
        pageKeywords: 'Kling 2.6 Pro, AI视频生成, 音画同步, 快手AI, 视频生成器, AI配音, 1080p视频, WeryAI',

        // 生成器部分
        generatorTitle: 'Kling 2.6 Pro 视频生成器',
        generatorDescription: 'WeryAI 現已深度整合Kling 2.6 Pro模型，Kling 2.6 Pro 是快手（Kuaishou）旗下 Kling AI 推出的一款革命性全能 AI 视频生成模型。作为 2.6 版本的专业旗舰款，它不仅继承了前代卓越的画质，更首创了"音画同步生成"能力，能在生成 1080p 高清视频的同时，自动合成精确匹配的对话、音效和环境音。这一突破性技术让创作者无需后期配音即可获得完整的视听作品，极大地提升了从创意到成片的效率。快来 WeryAI 免费体验 Kling 2.6 Pro 的影音同步魔法吧！',

        // 标签页
        tabImageToVideo: '图片生成视频',
        tabTextToVideo: '文本生成视频',

        // 核心功能部分
        coreFeaturesTitle: 'Kling 2.6 Pro 核心功能特性',

        // 功能特点
        feature1Title: '原生音画同步生成',
        feature1Description: 'Kling 2.6 Pro 打破了视频与音频分离生成的传统界限。它能根据画面内容，在一次推理中同时生成与动作精准对位的音效（如脚步声、碰撞声）以及自然的人声对话，确保"所见即所听"。',
        feature2Title: '中英双语语音支持',
        feature2Description: '模型内置了高质量的中英文语音引擎。用户只需在提示词中指定台词，即可生成口型对得上的角色对话，支持多种情感语调，非常适合制作叙事短片或营销广告。',
        feature3Title: '1080p 电影级画质与光影',
        feature3Description: '输出分辨率默认为 1080p，具备极高的视觉保真度。模型对光影反射、材质纹理（如皮肤、金属、水面）的理解达到了新的高度，画面细腻无噪点。',
        feature4Title: 'Elements 角色一致性控制',
        feature4Description: '通过"Elements"功能，用户可以上传参考图像来固定视频中的主角形象。即使在复杂的运镜或长镜头中，角色的面部特征和服装细节也能保持高度一致，不再"变脸"。',
        feature5Title: '长视频延伸与连贯性',
        feature5Description: '支持基础 10 秒生成，并可通过"Extend"功能多次延展视频时长（最高支持数分钟），同时保持动作的流畅性和逻辑的连贯性，适合制作长镜头叙事内容。',

        // 如何使用部分
        howToUseTitle: '如何在 WeryAI 上使用 Kling 2.6 Pro',
        step1Title: '选择模型',
        step1Description: '在 AI 视频工具中选择 Kling 2.6 Pro 模型',
        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',
        step3Title: '生成视频',
        step3Description: '点击生成按钮，等待并下载您的视频',

        // YouTube 视频部分
        youtubeTitle: '关于 Kling 2.6 Pro 的精彩视频介绍',

        // X Posts 部分
        xPostsTitle: '关于 Kling 2.6 Pro 的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索 WeryAI 上的其他工具',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma 夢想機器',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ 部分
        faqTitle: '常见问题',

        // CTA 部分
        ctaTitle: '立即体验 Kling 2.6 Pro',
        ctaDescription: '在 WeryAI 上免费开始创作音画同步的 AI 视频',
        ctaButton: '开始生成视频',
        ctaDisclaimer: '无需信用卡，注册即可使用',
    },
    pl: {

        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI Video Generator - Audio-Visual Synchronization | WeryAI',
        pageDescription: 'Kling 2.6 Pro is Kuaishou\'s revolutionary AI video generation model, pioneering audio-visual synchronization generation, supporting 1080p HD video, bilingual voice (Chinese/English), and character consistency control. Experience Kling 2.6 Pro for free on WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, AI video generation, audio-visual sync, Kuaishou AI, video generator, AI voiceover, 1080p video, WeryAI',

        // Generator section
        generatorTitle: 'Kling 2.6 Pro Video Generator',
        generatorDescription: 'WeryAI jest teraz głęboko zintegrowane z modelem Kling 2.6 Pro, Kling 2.6 Pro is a revolutionary all-in-one AI video generation model launched by Kling AI under Kuaishou. As the professional flagship of version 2.6, it not only inherits the excellent image quality of previous generations but also pioneers "audio-visual synchronization generation" capability, automatically synthesizing precisely matched dialogue, sound effects, and ambient sounds while generating 1080p HD video. This breakthrough technology allows creators to obtain complete audiovisual works without post-production dubbing, greatly improving efficiency from concept to finished product. Come experience the magic of Kling 2.6 Pro\'s audio-visual synchronization on WeryAI for free!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling 2.6 Pro Core Features',

        // Features
        feature1Title: 'Native Audio-Visual Synchronization',
        feature1Description: 'Kling 2.6 Pro breaks the traditional boundary of separate video and audio generation. It can simultaneously generate precisely synchronized sound effects (such as footsteps, collision sounds) and natural human dialogue in a single inference based on the visual content, ensuring "what you see is what you hear".',
        feature2Title: 'Bilingual Voice Support (Chinese/English)',
        feature2Description: 'The model has built-in high-quality Chinese and English voice engines. Users only need to specify dialogue in the prompt to generate character conversations with synchronized lip movements, supporting various emotional tones, perfect for creating narrative short films or marketing advertisements.',
        feature3Title: '1080p Cinematic Quality & Lighting',
        feature3Description: 'Output resolution defaults to 1080p with extremely high visual fidelity. The model\'s understanding of light reflection, material textures (such as skin, metal, water surfaces) has reached new heights, with fine details and no noise.',
        feature4Title: 'Elements Character Consistency Control',
        feature4Description: 'Through the "Elements" feature, users can upload reference images to fix the main character\'s appearance in the video. Even in complex camera movements or long shots, the character\'s facial features and clothing details remain highly consistent, no more "face swapping".',
        feature5Title: 'Long Video Extension & Coherence',
        feature5Description: 'Supports basic 10-second generation, and can extend video duration multiple times through the "Extend" feature (up to several minutes), while maintaining smooth motion and logical coherence, suitable for creating long-shot narrative content.',

        // How to use section
        howToUseTitle: 'How to Use Kling 2.6 Pro on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling 2.6 Pro model in the AI video tools.',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload a reference image.',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling 2.6 Pro',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Kling 2.6 Pro',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Tools on WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling 2.6 Pro Now',
        ctaDescription: 'Start creating audio-visual synchronized AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',

    },
    es: {
        // SEO Meta
        pageTitle: 'Generador de Videos AI Kling 2.6 Pro - Generación Synchronizada de Audio y Video | WeryAI',
        pageDescription: 'Kling 2.6 Pro es un revolucionario modelo de generación de videos AI de Kuaishou, pionero en la capacidad de generación sincronizada de audio y video. Admite videos en alta definición 1080p, voz bilingüe chino-inglés y control de coherencia de personajes. Prueba Kling 2.6 Pro gratuitamente en WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, generación de videos AI, sincronización de audio y video, Kuaishou AI, generador de videos, doblaje AI, video 1080p, WeryAI',

        // 生成器部分
        generatorTitle: 'Generador de Videos Kling 2.6 Pro',
        generatorDescription: 'WeryAI ahora integra profundamente el modelo Kling 2.6 Pro, Kling 2.6 Pro es un revolucionario modelo全能 de generación de videos AI lanzado por Kling AI, propiedad de Kuaishou. Como versión profesional y bandera de la serie 2.6, hereda la excelente calidad de imagen de las versiones anteriores y, además, es pionero en la capacidad de "generación sincronizada de audio y video". Puede generar videos en alta definición 1080p y, al mismo tiempo, sintetizar automáticamente diálogos, efectos de sonido y audio ambiental que coinciden con precisión. Esta tecnología innovadora permite a los creadores obtener obras audiovisuales completas sin necesidad de doblaje posterior, aumentando enormemente la eficiencia desde la idea hasta la obra final. ¡Ven a probar gratuitamente la magia de sincronización audiovisual de Kling 2.6 Pro en WeryAI!',

        // 标签页
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',

        // 核心功能部分
        coreFeaturesTitle: 'Características Principales de Kling 2.6 Pro',

        // 功能特点
        feature1Title: 'Generación Nativa Synchronizada de Audio y Video',
        feature1Description: 'Kling 2.6 Pro rompe los límites tradicionales de la generación separada de video y audio. Según el contenido de la imagen, puede generar simultáneamente en una sola inferencia efectos de sonido que coinciden precisamente con las acciones (como pasos, golpes) y diálogos humanos naturales, garantizando que "lo que se vea sea lo que se escuche".',
        feature2Title: 'Soporte de Voz Bilingüe Chino-Inglés',
        feature2Description: 'El modelo integra un motor de voz de alta calidad en chino e inglés. Los usuarios solo necesitan especificar los diálogos en el prompt para generar conversaciones de personajes con labios sincronizados, admitiendo varios tonos emocionales, ideal para la creación de cortometrajes narrativos o anuncios de marketing.',
        feature3Title: 'Calidad Cinematográfica 1080p y Efectos de Luz y Sombra',
        feature3Description: 'La resolución de salida es 1080p por defecto, con una muy alta fidelidad visual. El modelo ha alcanzado un nuevo nivel en la comprensión de reflejos de luz y sombra, texturas de materiales (como piel, metal, agua), con imágenes detalladas y sin ruido.',
        feature4Title: 'Control de Coherencia de Personajes con Elements',
        feature4Description: 'Mediante la función "Elements", los usuarios pueden subir imágenes de referencia para fijar la apariencia del personaje principal en el video. Incluso en movimientos de cámara complejos o tomas largas, las características faciales y los detalles de la ropa del personaje pueden mantenerse altamente consistentes, sin más "cambios de rostro".',
        feature5Title: 'Extensión de Video Largo y Coherencia',
        feature5Description: 'Admite la generación básica de 10 segundos y puede extender la duración del video múltiples veces mediante la función "Extend" (hasta varios minutos), manteniendo la fluidez de las acciones y la coherencia lógica, ideal para la creación de contenido narrativo con tomas largas.',

        // 如何使用部分
        howToUseTitle: 'Cómo usar Kling 2.6 Pro en WeryAI',
        step1Title: 'Seleccionar modelo',
        step1Description: 'Seleccione el modelo Kling 2.6 Pro en las herramientas de video AI.',
        step2Title: 'Ingresar contenido',
        step2Description: 'Ingrese un prompt o suba una imagen de referencia.',
        step3Title: 'Generar video',
        step3Description: 'Haga clic en el botón generar, espere y descargue su video.',

        // YouTube 视频部分
        youtubeTitle: 'Excelentes Videos Introductorios sobre Kling 2.6 Pro',

        // X Posts 部分
        xPostsTitle: 'Publicaciones populares en X sobre Kling 2.6 Pro',

        // 探索其他模型部分
        exploreModelsTitle: 'Explora Otras Herramientas en WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ 部分
        faqTitle: 'Preguntas Frecuentes',

        // CTA 部分
        ctaTitle: 'Prueba Kling 2.6 Pro Ahora',
        ctaDescription: 'Comienza a crear videos AI con sincronización de audio y video gratuitamente en WeryAI',
        ctaButton: 'Comenzar a Generar Video',
        ctaDisclaimer: 'No se requiere tarjeta de crédito, solo regístrate para usar',
    },
    fr: {
        // SEO Meta
        pageTitle: 'Générateur de Vidéos IA Kling 2.6 Pro - Génération Synchronisée Audio-Vidéo | WeryAI',
        pageDescription: 'Kling 2.6 Pro est un modèle révolutionnaire de génération de vidéos IA de Kuaishou, pionnier dans la capacité de génération synchronisée audio-vidéo. Prend en charge les vidéos en haute définition 1080p, la voix bilingue chinois-anglais et le contrôle de cohérence des personnages. Essayez Kling 2.6 Pro gratuitement sur WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, génération de vidéos IA, synchronisation audio-vidéo, Kuaishou AI, générateur de vidéos, doublage IA, vidéo 1080p, WeryAI',

        // 生成器部分
        generatorTitle: 'Générateur de Vidéos Kling 2.6 Pro',
        generatorDescription: 'WeryAI intègre désormais en profondeur le modèle Kling 2.6 Pro, Kling 2.6 Pro est un modèle révolutionnaire et polyvalent de génération de vidéos IA lancé par Kling AI, une filiale de Kuaishou. En tant que version professionnelle phare de la série 2.6, il hérite de la excellente qualité d\'image des versions précédentes et, de plus, est pionnier dans la capacité de "génération synchronisée audio-vidéo". Il peut générer des vidéos en haute définition 1080p et, simultanément, synthétiser automatiquement des dialogues, des effets sonores et un audio ambiant qui correspondent avec précision. Cette technologie innovante permet aux créateurs d\'obtenir des œuvres audiovisuelles complètes sans besoin de doublage postérieur, augmentant considérablement l\'efficacité depuis l\'idée jusqu\'à la réalisation finale. Venez essayer gratuitement la magie de synchronisation audiovisuelle de Kling 2.6 Pro sur WeryAI !',

        // 标签页
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',

        // 核心功能部分
        coreFeaturesTitle: 'Caractéristiques Principales de Kling 2.6 Pro',

        // 功能特点
        feature1Title: 'Génération NATIVE Synchronisée Audio-Vidéo',
        feature1Description: 'Kling 2.6 Pro brise les limites traditionnelles de la génération séparée de vidéo et d\'audio. Selon le contenu de l\'image, il peut générer simultanément en une seule inférence des effets sonores correspondant précisément aux actions (tels que des pas, des chocs) et des dialogues humains naturels, garantissant que "ce qui est vu est ce qui est entendu".',
        feature2Title: 'Support de Voix Bilingue Chinois-Anglais',
        feature2Description: 'Le modèle intègre un moteur vocal de haute qualité en chinois et en anglais. Les utilisateurs n\'ont qu\'à spécifier les dialogues dans le prompt pour générer des conversations de personnages avec lèvres synchronisées, supportant plusieurs tons émotionnels, idéal pour la création de courts-métrages narratifs ou de publicités marketing.',
        feature3Title: 'Qualité Cinématographique 1080p et Éclairage-Ombrage',
        feature3Description: 'La résolution de sortie est 1080p par défaut, avec une très haute fidélité visuelle. Le modèle a atteint un nouveau niveau dans la compréhension des reflets lumière-ombre, des textures de matériaux (telle que la peau, le métal, l\'eau), avec des images détaillées et sans bruit.',
        feature4Title: 'Contrôle de Cohérence des Personnages avec Elements',
        feature4Description: 'Via la fonction "Elements", les utilisateurs peuvent télécharger des images de référence pour fixer l\'apparence du personnage principal dans la vidéo. Même dans des mouvements de caméra complexes ou des plans longs, les caractéristiques faciales et les détails vestimentaires du personnage peuvent rester hautement cohérents, sans plus de "changement de visage".',
        feature5Title: 'Extension de Vidéo Longue et Cohérence',
        feature5Description: 'Prend en charge la génération de base de 10 secondes et peut étendre la durée de la vidéo plusieurs fois via la fonction "Extend" (jusqu\'à plusieurs minutes), maintenant la fluidité des actions et la cohérence logique, idéal pour la création de contenu narratif avec des plans longs.',

        // 如何使用部分
        howToUseTitle: 'Comment utiliser Kling 2.6 Pro sur WeryAI',
        step1Title: 'Sélectionner le modèle',
        step1Description: 'Sélectionnez le modèle Kling 2.6 Pro dans les outils vidéo IA.',
        step2Title: 'Saisir le contenu',
        step2Description: 'Saisissez un prompt ou téléchargez une image de référence.',
        step3Title: 'Générer la vidéo',
        step3Description: 'Cliquez sur le bouton générer, attendez et téléchargez votre vidéo.',

        // YouTube 视频部分
        youtubeTitle: 'Excellentes Vidéos de Présentation sur Kling 2.6 Pro',

        // X Posts 部分
        xPostsTitle: 'Publications populaires sur X à propos de Kling 2.6 Pro',

        // 探索其他模型部分
        exploreModelsTitle: 'Découvrez d\'Autres Outils sur WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ 部分
        faqTitle: 'Questions Fréquentes',

        // CTA 部分
        ctaTitle: 'Essayez Kling 2.6 Pro Maintenant',
        ctaDescription: 'Commencez à créer des vidéos IA avec synchronisation audio-vidéo gratuitement sur WeryAI',
        ctaButton: 'Commencer à Générer une Vidéo',
        ctaDisclaimer: 'Aucune carte de crédit requise, inscrivez-vous et utilisez',
    },
    de: {
        // SEO Meta
        pageTitle: 'Kling 2.6 Pro KI-Videogenerator - Synchronisierte Audio-Video-Generierung | WeryAI',
        pageDescription: 'Kling 2.6 Pro ist ein revolutionäres KI-Videogenerierungsmodell von Kuaishou, Pionier in der Fähigkeit zur synchronisierten Audio-Video-Generierung. Unterstützt 1080p-HD-Videos, chinesisch-englische Zweisprachige Stimme und Charakterkonsistenzkontrolle. Testen Sie Kling 2.6 Pro kostenlos auf WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, KI-Videogenerierung, Audio-Video-Synchronisation, Kuaishou AI, Videogenerator, KI-Dublage, 1080p-Video, WeryAI',

        // 生成器部分
        generatorTitle: 'Kling 2.6 Pro Videogenerator',
        generatorDescription: 'WeryAI integriert jetzt das Modell Kling 2.6 Pro tiefgreifend, Kling 2.6 Pro ist ein revolutionäres, vielseitiges KI-Videogenerierungsmodell von Kling AI, einem Tochterunternehmen von Kuaishou. Als professionelle Spitzenversion der 2.6-Serie erbt es die hervorragende Bildqualität früherer Versionen und ist zudem Pionier in der "synchronisierten Audio-Video-Generierung". Es kann 1080p-HD-Videos generieren und gleichzeitig automatisch passende Dialoge, Geräuscheffekte und Umgebungsgeräusche synthetisieren. Diese innovative Technologie ermöglicht Kreativen, vollständige audiovisuelle Werke ohne nachträgliches Dubbing zu erhalten – dies steigert die Effizienz von der Idee bis zum fertigen Produkt erheblich. Kommen Sie und testen Sie die Magie der audiovisuellen Synchronisation von Kling 2.6 Pro kostenlos auf WeryAI!',

        // 标签页
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // 核心功能部分
        coreFeaturesTitle: 'Hauptfunktionen von Kling 2.6 Pro',

        // 功能特点
        feature1Title: 'Native Synchronisierte Audio-Video-Generierung',
        feature1Description: 'Kling 2.6 Pro bricht die traditionellen Grenzen der separaten Video- und Audiogenerierung. Anhand des Bildinhalts kann es in einem einzigen Inferenzschritt gleichzeitig Geräuscheffekte generieren, die genau zu Bewegungen passen (z. B. Schritte, Stöße) sowie natürliche menschliche Dialoge – sodass "Gesehenes auch Gehörtes ist".',
        feature2Title: 'Unterstützung für Chinesisch-Englische Zweisprachige Stimme',
        feature2Description: 'Das Modell integriert eine hochwertige Sprachengine in Chinesisch und Englisch. Benutzer müssen nur Dialoge im Prompt angeben, um Charaktergespräche mit synchronisierten Lippen zu generieren – mit Unterstützung für verschiedene emotionale Tonleitern, ideal für die Erstellung von narrativen Kurzfilmen oder Marketingwerbung.',
        feature3Title: '1080p Kinoqualität und Licht-Schatten-Effekte',
        feature3Description: 'Die Ausgaberesolution beträgt standardmäßig 1080p mit sehr hoher visueller Treue. Das Modell hat ein neues Niveau in der Verständnis von Lichtreflexionen, Materialtexturen (z. B. Haut, Metall, Wasser) erreicht – mit detailreichen, rauschfreien Bildern.',
        feature4Title: 'Charakterkonsistenzkontrolle mit Elements',
        feature4Description: 'Mit der "Elements"-Funktion können Benutzer Referenzbilder hochladen, um das Aussehen des Hauptcharakters im Video zu fixieren. Selbst bei komplexen Kamerabewegungen oder Langtakes bleiben die Gesichtszüge und Kleidedetails des Charakters hochkonsistent – ohne mehr "Gesichtswechsel".',
        feature5Title: 'Langvideo-Extension und Konsistenz',
        feature5Description: 'Unterstützt die Basisgenerierung von 10 Sekunden und kann die Videodauer über die "Extend"-Funktion mehrmals erweitern (bis zu mehreren Minuten) – bei gleichbleibender Bewegungsfluidität und logischer Konsistenz, ideal für die Erstellung von narrativen Inhalten mit Langtakes.',

        // 如何使用部分
        howToUseTitle: 'So verwenden Sie Kling 2.6 Pro auf WeryAI',
        step1Title: 'Modell auswählen',
        step1Description: 'Wählen Sie das Modell Kling 2.6 Pro in den KI-Videotools aus.',
        step2Title: 'Inhalt eingeben',
        step2Description: 'Geben Sie einen Prompt ein oder laden Sie ein Referenzbild hoch.',
        step3Title: 'Video generieren',
        step3Description: 'Klicken Sie auf den Generieren-Button, warten Sie und laden Sie Ihr Video herunter.',

        // YouTube 视频部分
        youtubeTitle: 'Exzellente Videoeinführungen zu Kling 2.6 Pro',

        // X Posts 部分
        xPostsTitle: 'Beliebte X-Beiträge zu Kling 2.6 Pro',

        // 探索其他模型部分
        exploreModelsTitle: 'Entdecken Sie weitere Tools auf WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ 部分
        faqTitle: 'Häufig gestellte Fragen',

        // CTA 部分
        ctaTitle: 'Testen Sie Kling 2.6 Pro jetzt',
        ctaDescription: 'Beginnen Sie kostenlos mit der Erstellung von KI-Videos mit Audio-Video-Synchronisation auf WeryAI',
        ctaButton: 'Video generieren starten',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich, einfach registrieren und nutzen',
    },
    ru: {
        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI Генератор видео - Синхронная генерация аудио и видео | WeryAI',
        pageDescription: 'Kling 2.6 Pro — революционная AI-модель генерации видео от Kuaishou, первая с возможностью синхронной генерации аудио и видео, поддерживает высококачественное видео 1080p, двуязычную речь (китайский и английский) и контроль согласованности персонажей. Пробуйте Kling 2.6 Pro бесплатно на WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, AI генерация видео, синхронность аудио и видео, Kuaishou AI, генератор видео, AI озвучка, видео 1080p, WeryAI',

        // 生成器部分
        generatorTitle: 'Kling 2.6 Pro Генератор видео',
        generatorDescription: 'WeryAI теперь глубоко интегрировал модель Kling 2.6 Pro, Kling 2.6 Pro — это революционная универсальная AI-модель генерации видео от Kling AI, принадлежащей Kuaishou. Как профессиональная флагманская версия 2.6, она не только унаследовала превосходное качество изображения предыдущих версий, но и впервые представила функцию "синхронной генерации аудио и видео", позволяя автоматически синтезировать точно совпадающие диалоги, звуковые эффекты и фоновые звуки при генерации высококачественного видео 1080p. Эта прорывная технология позволяет создателям получать полноценные аудиовизуальные работы без постобработки и озвучки, значительно повысив эффективность от идеи до готового ролика. Пробуйте магию синхронного аудио и видео Kling 2.6 Pro бесплатно на WeryAI!',

        // 标签页
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',

        // 核心功能部分
        coreFeaturesTitle: 'Основные функции Kling 2.6 Pro',

        // 功能特点
        feature1Title: 'Нативная синхронная генерация аудио и видео',
        feature1Description: 'Kling 2.6 Pro сломал традиционные границы разделенной генерации видео и аудио. На основе содержания кадра она может одновременно генерировать звуковые эффекты, точно соответствующие движениям (например, шаги, столкновения) и естественные человеческие диалоги за один проход推理, гарантируя "то, что видишь — то и слышишь".',
        feature2Title: 'Поддержка двуязычной речи (китайский и английский)',
        feature2Description: 'Модель оснащена высококачественным двуязычным аудио-двигателем (китайский и английский). Пользователям достаточно указать реплики в промпте, чтобы получить диалоги персонажей с синхронными движениями губ, поддерживающие различные эмоциональные интонации — идеально для создания повествовательных короткометражек или рекламных роликов.',
        feature3Title: 'Кинематографическое качество изображения 1080p и освещение',
        feature3Description: 'Стандартное разрешение вывода — 1080p с высокой визуальной точностью. Модель достигла нового уровня понимания световых отражений и текстур материалов (например, кожа, металл, вода), изображение детализированное и без шумов.',
        feature4Title: 'Elements — контроль согласованности персонажей',
        feature4Description: 'С помощью функции "Elements" пользователи могут загружать эталонные изображения для фиксации внешнего вида главного персонажа в видео. Даже при сложных камерных движениях или длинных кадрах черты лица и детали одежды персонажа остаются высоко согласованными, без "смены лица".',
        feature5Title: 'Расширение длинных видео и согласованность',
        feature5Description: 'Поддерживает базовую генерацию видео длительностью 10 секунд, а с помощью функции "Extend" можно многократно увеличивать длительность (до нескольких минут), сохраняя плавность движений и логическую согласованность — идеально для создания повествовательных длинных кадров.',

        // 如何使用部分
        howToUseTitle: 'Как использовать Kling 2.6 Pro на WeryAI',
        step1Title: 'Выберите модель',
        step1Description: 'Выберите модель Kling 2.6 Pro в инструментах AI видео.',
        step2Title: 'Введите содержание',
        step2Description: 'Введите промпт или загрузите эталонное изображение.',
        step3Title: 'Сгенерировать видео',
        step3Description: 'Нажмите кнопку генерации, подождите и скачайте ваше видео.',

        // YouTube 视频部分
        youtubeTitle: 'Интересные видеоролики о Kling 2.6 Pro',

        // X Posts 部分
        xPostsTitle: 'Популярные посты в X о Kling 2.6 Pro',

        // 探索其他模型部分
        exploreModelsTitle: 'Откройте для себя другие инструменты на WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ 部分
        faqTitle: 'Часто задаваемые вопросы',

        // CTA 部分
        ctaTitle: 'Попробуйте Kling 2.6 Pro прямо сейчас',
        ctaDescription: 'Начните создавать синхронные аудиовизуальные AI-видео бесплатно на WeryAI',
        ctaButton: 'Начать генерацию видео',
        ctaDisclaimer: 'Без кредитной карты — достаточно зарегистрироваться',
    },
    pt: {
        // SEO Meta
        pageTitle: 'Gerador de Vídeo AI Kling 2.6 Pro - Geração Sincronizada de Áudio e Vídeo | WeryAI',
        pageDescription: 'Kling 2.6 Pro é um modelo revolucionário de geração de vídeo AI da Kuaishou, pioneiro na capacidade de geração sincronizada de áudio e vídeo, suporta vídeo em alta definição 1080p, voz bilingue (chinês e inglês) e controle de consistência de personagens. Experimente o Kling 2.6 Pro gratuitamente na WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, geração de vídeo AI, sincronização de áudio e vídeo, Kuaishou AI, gerador de vídeo, dublagem AI, vídeo 1080p, WeryAI',

        // 生成器部分
        generatorTitle: 'Gerador de Vídeo Kling 2.6 Pro',
        generatorDescription: 'O WeryAI agora integra profundamente o modelo Kling 2.6 Pro, Kling 2.6 Pro é um modelo revolucionário e all-in-one de geração de vídeo AI da Kling AI, pertencente à Kuaishou. Como versão profissional sinalizadora da 2.6, ele não só herdou a excelente qualidade de imagem das versões anteriores, mas também lançou pela primeira vez a capacidade de "geração sincronizada de áudio e vídeo", podendo gerar automaticamente diálogos, efeitos sonoros e sons ambientais precisamente alinhados ao criar vídeo em alta definição 1080p. Essa tecnologia inovadora permite que criadores obtenham obras audiovisuais completas sem necessidade de dublagem pós-produção, aumentando significativamente a eficiência desde a ideia até o vídeo final. Venha experimentar a magia da sincronização de áudio e vídeo do Kling 2.6 Pro gratuitamente na WeryAI!',

        // 标签页
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',

        // 核心功能部分
        coreFeaturesTitle: 'Características Principais do Kling 2.6 Pro',

        // 功能特点
        feature1Title: 'Geração Nativa Sincronizada de Áudio e Vídeo',
        feature1Description: 'Kling 2.6 Pro quebrou as fronteiras tradicionais da geração separada de vídeo e áudio. Com base no conteúdo da imagem, ele pode gerar simultaneamente efeitos sonoros alinhados precisamente com movimentos (como passos, colisões) e diálogos humanos naturais em uma única inferência, garantindo "o que você vê é o que você ouve".',
        feature2Title: 'Suporte a Voz Bilingue (Chinês e Inglês)',
        feature2Description: 'O modelo possui um motor de voz de alta qualidade bilingue (chinês e inglês). Os usuários só precisam especificar as falas no prompt para gerar diálogos de personagens com sincronismo labial, suportando vários tons emocionais — ideal para criar curtas narrativas ou anúncios de marketing.',
        feature3Title: 'Qualidade Cinematográfica 1080p e Iluminação',
        feature3Description: 'A resolução de saída padrão é 1080p com alta fidelidade visual. O modelo atingiu um novo nível de compreensão de reflexos de luz e texturas de materiais (como pele, metal, água), com imagem detalhada e sem ruído.',
        feature4Title: 'Elements — Controle de Consistência de Personagens',
        feature4Description: 'Através da função "Elements", os usuários podem fazer upload de imagens de referência para fixar a aparência do personagem principal no vídeo. Mesmo em movimentos de câmera complexos ou takes longos, as características faciais e detalhes da roupa do personagem permanecem altamente consistentes, sem "mudança de rosto".',
        feature5Title: 'Extensão de Vídeos Longos e Consistência',
        feature5Description: 'Suporta geração básica de vídeo de 10 segundos, e com a função "Extend" é possível ampliar a duração do vídeo múltiplas vezes (até vários minutos), mantendo a fluidez dos movimentos e consistência lógica — ideal para criar conteúdo narrativo em takes longos.',

        // 如何使用部分
        howToUseTitle: 'Como usar o Kling 2.6 Pro na WeryAI',
        step1Title: 'Selecionar Modelo',
        step1Description: 'Selecione o modelo Kling 2.6 Pro nas ferramentas de vídeo AI.',
        step2Title: 'Inserir Conteúdo',
        step2Description: 'Insira um prompt ou faça upload de uma imagem de referência.',
        step3Title: 'Gerar Vídeo',
        step3Description: 'Clique no botão gerar, aguarde e baixe seu vídeo.',

        // YouTube 视频部分
        youtubeTitle: 'Excelentes Vídeos de Apresentação sobre o Kling 2.6 Pro',

        // X Posts 部分
        xPostsTitle: 'Postagens populares no X sobre o Kling 2.6 Pro',

        // 探索其他模型部分
        exploreModelsTitle: 'Explore Outras Ferramentas na WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ 部分
        faqTitle: 'Perguntas Frequentes',

        // CTA 部分
        ctaTitle: 'Experimente o Kling 2.6 Pro Agora',
        ctaDescription: 'Comece a criar vídeos AI audiovisuais sincronizados gratuitamente na WeryAI',
        ctaButton: 'Começar a Gerar Vídeo',
        ctaDisclaimer: 'Sem cartão de crédito, basta se registrar para usar',
    },
    it: {
        // SEO Meta
        pageTitle: 'Generatore di Video AI Kling 2.6 Pro - Generazione Sincronizzata di Audio e Video | WeryAI',
        pageDescription: 'Kling 2.6 Pro è un modello rivoluzionario di generazione di video AI della Kuaishou, pioniero nella capacità di generazione sincronizzata di audio e video, supporta video in alta definizione 1080p, voce bilingue (cinese e inglese) e controllo di coerenza dei personaggi. Prova il Kling 2.6 Pro gratuitamente su WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, generazione di video AI, sincronizzazione audio e video, Kuaishou AI, generatore di video, doppiaggio AI, video 1080p, WeryAI',

        // 生成器部分
        generatorTitle: 'Generatore di Video Kling 2.6 Pro',
        generatorDescription: 'WeryAI integra ora in profondità il modello Kling 2.6 Pro, Kling 2.6 Pro è un modello rivoluzionario e all-in-one di generazione di video AI della Kling AI, appartenente alla Kuaishou. Come versione professionale bandiera della 2.6, ha ereditato non solo l\'eccellente qualità delle immagini delle versioni precedenti, ma ha anche introdotto per la prima volta la capacità di "generazione sincronizzata di audio e video", potendo generare automaticamente dialoghi, effetti sonori e suoni ambientali precisamente allineati durante la creazione di video in alta definizione 1080p. Questa tecnologia innovativa permette ai creatori di ottenere opere audiovisive complete senza doppiaggio post-produzione, aumentando significativamente l\'efficienza dall\'idea al video finale. Vieni a provare la magia della sincronizzazione audio e video di Kling 2.6 Pro gratuitamente su WeryAI!',

        // 标签页
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',

        // 核心功能部分
        coreFeaturesTitle: 'Caratteristiche Principali del Kling 2.6 Pro',

        // 功能特点
        feature1Title: 'Generazione Nativa Sincronizzata di Audio e Video',
        feature1Description: 'Kling 2.6 Pro ha rotto le frontiere tradizionali della generazione separata di video e audio. Basandosi sul contenuto dell\'immagine, può generare simultaneamente effetti sonori precisamente allineati ai movimenti (come passi, collisioni) e dialoghi umani naturali in un singolo passaggio di inferenza, garantendo "quello che vedi è quello che senti".',
        feature2Title: 'Supporto per Voci Bilingue (Cinese e Inglese)',
        feature2Description: 'Il modello è equipaggiato con un motore vocale di alta qualità bilingue (cinese e inglese). Gli utenti hanno solo bisogno di specificare le frasi nel prompt per generare dialoghi dei personaggi con sincronizzazione labiale, supportando vari toni emotivi — ideale per creare cortometraggi narrativi o spot pubblicitari.',
        feature3Title: 'Qualità Cinematografica 1080p e Illuminazione',
        feature3Description: 'La risoluzione di output standard è 1080p con alta fedeltà visiva. Il modello ha raggiunto un nuovo livello di comprensione dei riflessi della luce e delle texture dei materiali (come pelle, metallo, acqua), con immagine dettagliata e senza rumori.',
        feature4Title: 'Elements — Controllo di Coerenza dei Personaggi',
        feature4Description: 'Attraverso la funzione "Elements", gli utenti possono caricare immagini di riferimento per fissare l\'aspetto del personaggio principale nel video. Anche in movimenti di macchina complessi o in take lunghi, le caratteristiche facciali e i dettagli dell\'abbigliamento del personaggio rimangono altamente coerenti, senza "cambio di volto".',
        feature5Title: 'Estensione di Video Lunghi e Coerenza',
        feature5Description: 'Supporta la generazione base di video di 10 secondi, e con la funzione "Extend" è possibile aumentare più volte la durata del video (fino a diversi minuti), mantenendo la fluidità dei movimenti e la coerenza logica — ideale per creare contenuti narrativi in take lunghi.',

        // 如何使用部分
        howToUseTitle: 'Come usare Kling 2.6 Pro su WeryAI',
        step1Title: 'Seleziona Modello',
        step1Description: 'Seleziona il modello Kling 2.6 Pro negli strumenti video AI.',
        step2Title: 'Inserisci Contenuto',
        step2Description: 'Inserisci un prompt o carica un\'immagine di riferimento.',
        step3Title: 'Genera Video',
        step3Description: 'Clicca sul pulsante genera, attendi e scarica il tuo video.',

        // YouTube 视频部分
        youtubeTitle: 'Eccellenti Video di Presentazione su Kling 2.6 Pro',

        // X Posts 部分
        xPostsTitle: 'Post popolari su X riguardanti Kling 2.6 Pro',

        // 探索其他模型部分
        exploreModelsTitle: 'Esplora Altri Strumenti su WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ 部分
        faqTitle: 'Domande Frequenti',

        // CTA 部分
        ctaTitle: 'Prova Kling 2.6 Pro Subito',
        ctaDescription: 'Inizia a creare video AI audiovisivi sincronizzati gratuitamente su WeryAI',
        ctaButton: 'Inizia a Generare Video',
        ctaDisclaimer: 'Nessuna carta di credito necessaria, basta registrarsi per usare',
    },
    ar: {
        // SEO Meta
        pageTitle: 'مولد الفيديو الاصطناعي Kling 2.6 Pro - توليد متزامن للصوت والفيديو | WeryAI',
        pageDescription: 'Kling 2.6 Pro هو نموذج ثوري لتوليد الفيديو الاصطناعي من كوالشو (Kuaishou)، البادئ في قدرة توليد متزامن للصوت والفيديو، يدعم الفيديو عالي الدقة 1080p، الصوت ثنائي اللغة (الصينية والإنجليزية)، والتحكم في الاتساق في الشخصيات. جرب Kling 2.6 Pro مجانًا على WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, توليد الفيديو الاصطناعي, تزام الصوت والفيديو, كوالشو AI, مولد الفيديو, تعليق صوتي اصطناعي, فيديو 1080p, WeryAI',

        // 生成器部分
        generatorTitle: 'مولد الفيديو Kling 2.6 Pro',
        generatorDescription: 'يقوم WeryAI الآن بدمج نموذج Kling 2.6 Pro بعمق، Kling 2.6 Pro هو نموذج ثوري وشامل لتوليد الفيديو الاصطناعي من Kling AI التابع لـ Kuaishou. كنسخة احترافية رائدة من الإصدار 2.6، لم تكتسب فقط جودة الصورة المذهلة من الإصدارات السابقة، بل قدمت أيضًا لأول مرة قدرة "التوليد المتزامن للصوت والفيديو"، حيث يمكنها توليد نطاقات محادثة، وتأثيرات صوتية، وصوتات بيئية مطابقة بدقة أثناء إنشاء الفيديو عالي الدقة 1080p. هذه التقنية الابتكارية تسمح للمبدعين بالحصول على أعمال سمعية بصرية كاملة دون الحاجة لتعليق صوتي ما بعد الإنتاج، مما يزيد بشكل كبير من الكفاءة من الفكرة إلى الفيديو النهائي. تعال جرب سحر التزام الصوت والفيديو في Kling 2.6 Pro مجانًا على WeryAI!',

        // 标签页
        tabImageToVideo: 'تحويل الصورة إلى فيديو',
        tabTextToVideo: 'تحويل النص إلى فيديو',

        // 核心功能部分
        coreFeaturesTitle: 'الميزات الرئيسية لـ Kling 2.6 Pro',

        // 功能特点
        feature1Title: 'توليد متزامن أصلي للصوت والفيديو',
        feature1Description: 'كسر Kling 2.6 Pro الحدود التقليدية لتوليد الفيديو والصوت بشكل منفصل. بناءً على محتوى الصورة، يمكنها توليد تأثيرات صوتية مطابقة بدقة للحركات (مثل خطوات الأقدام، الاصطدامات) ومحادثات بشرية طبيعية في عملية استنتاج واحدة، مما يضمن "ما تراه هو ما تسمعه".',
        feature2Title: 'دعم الصوت ثنائي اللغة (الصينية والإنجليزية)',
        feature2Description: 'يحتوي النموذج على محرك صوتي عالي الجودة ثنائي اللغة (الصينية والإنجليزية). يحتاج المستخدمون فقط إلى تحديد النطاقات في المقدم (Prompt) لإنشاء محادثات شخصيات مع تزام شفاه، مع دعم نغمات عاطفية مختلفة — مثالي لإنشاء مقاطع قصيرة سردية أو إعلانات تسويقية.',
        feature3Title: 'جودة سينمائية 1080p والإضاءة',
        feature3Description: 'دقة الإخراج القياسية هي 1080p مع دقة بصرية عالية. وصل النموذج إلى مستوى جديد من فهم انعكاسات الضوء وملمس المواد (مثل الجلد، المعدن، الماء)، مع صورة مفصلة وبدون ضوضاء.',
        feature4Title: 'Elements — التحكم في الاتساق في الشخصيات',
        feature4Description: 'من خلال وظيفة "Elements"، يمكن للمستخدمين تحميل صور مرجعية لتثبيت مظهر الشخصية الرئيسية في الفيديو. حتى في حركات كاميرا معقدة أو لقطات طويلة، تظل سمات وجه الشخصية وتفاصيل الملابس متسقة للغاية، دون "تغيير وجه".',
        feature5Title: 'توسيع الفيديوهات الطويلة والاتساق',
        feature5Description: 'يدعم توليد فيديو أساسي длительته 10 ثوانٍ، ويمكن باستخدام وظيفة "Extend" زيادة طول الفيديو عدة مرات (حتى عدة دقائق)، مع الحفاظ على سلاسة الحركات والاتساق المنطقي — مثالي لإنشاء محتوى سردي في لقطات طويلة.',

        // 如何使用部分
        howToUseTitle: 'كيفية استخدام Kling 2.6 Pro على WeryAI',
        step1Title: 'اختر النموذج',
        step1Description: 'اختر نموذج Kling 2.6 Pro في أدوات الفيديو بالذكاء الاصطناعي.',
        step2Title: 'إدخال المحتوى',
        step2Description: 'أدخل موجهًا (Prompt) أو قم بتحميل صورة مرجعية.',
        step3Title: 'توليد الفيديو',
        step3Description: 'انقر فوق زر التوليد، انتظر وقم بتنزيل الفيديو الخاص بك.',

        // YouTube 视频部分
        youtubeTitle: 'مقاطع فيديو رائعة عن Kling 2.6 Pro',

        // X Posts 部分
        xPostsTitle: 'منشورات X الرائجة حول Kling 2.6 Pro',

        // 探索其他模型部分
        exploreModelsTitle: 'اكتشف الأدوات الأخرى على WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ 部分
        faqTitle: 'الأسئلة الشائعة',

        // CTA 部分
        ctaTitle: 'جرب Kling 2.6 Pro الآن',
        ctaDescription: 'ابدأ في إنشاء فيديوهات اصطناعية سمعية بصرية متزامنة مجانًا على WeryAI',
        ctaButton: 'ابدأ في توليد الفيديو',
        ctaDisclaimer: 'لا يلزم بطاقة ائتمان، يمكن الاستخدام بمجرد التسجيل',
        },
    th: { // Thai (copied from English)
        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI Video Generator - Audio-Visual Synchronization | WeryAI',
        pageDescription: 'Kling 2.6 Pro is Kuaishou\'s revolutionary AI video generation model, pioneering audio-visual synchronization generation, supporting 1080p HD video, bilingual voice (Chinese/English), and character consistency control. Experience Kling 2.6 Pro for free on WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, AI video generation, audio-visual sync, Kuaishou AI, video generator, AI voiceover, 1080p video, WeryAI',

        // Generator section
        generatorTitle: 'Kling 2.6 Pro Video Generator',
        generatorDescription: 'ขณะนี้ WeryAI ได้ผสานรวมโมเดล Kling 2.6 Pro อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล Kling 2.6 Pro อย่างลึกซึ้งแล้ว Kling 2.6 Pro is a revolutionary all-in-one AI video generation model launched by Kling AI under Kuaishou. As the professional flagship of version 2.6, it not only inherits the excellent image quality of previous generations but also pioneers "audio-visual synchronization generation" capability, automatically synthesizing precisely matched dialogue, sound effects, and ambient sounds while generating 1080p HD video. This breakthrough technology allows creators to obtain complete audiovisual works without post-production dubbing, greatly improving efficiency from concept to finished product. Come experience the magic of Kling 2.6 Pro\'s audio-visual synchronization on WeryAI for free!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling 2.6 Pro Core Features',

        // Features
        feature1Title: 'Native Audio-Visual Synchronization',
        feature1Description: 'Kling 2.6 Pro breaks the traditional boundary of separate video and audio generation. It can simultaneously generate precisely synchronized sound effects (such as footsteps, collision sounds) and natural human dialogue in a single inference based on the visual content, ensuring "what you see is what you hear".',
        feature2Title: 'Bilingual Voice Support (Chinese/English)',
        feature2Description: 'The model has built-in high-quality Chinese and English voice engines. Users only need to specify dialogue in the prompt to generate character conversations with synchronized lip movements, supporting various emotional tones, perfect for creating narrative short films or marketing advertisements.',
        feature3Title: '1080p Cinematic Quality & Lighting',
        feature3Description: 'Output resolution defaults to 1080p with extremely high visual fidelity. The model\'s understanding of light reflection, material textures (such as skin, metal, water surfaces) has reached new heights, with fine details and no noise.',
        feature4Title: 'Elements Character Consistency Control',
        feature4Description: 'Through the "Elements" feature, users can upload reference images to fix the main character\'s appearance in the video. Even in complex camera movements or long shots, the character\'s facial features and clothing details remain highly consistent, no more "face swapping".',
        feature5Title: 'Long Video Extension & Coherence',
        feature5Description: 'Supports basic 10-second generation, and can extend video duration multiple times through the "Extend" feature (up to several minutes), while maintaining smooth motion and logical coherence, suitable for creating long-shot narrative content.',

        // How to use section
        howToUseTitle: 'How to Use Kling 2.6 Pro on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling 2.6 Pro model in the AI video tools.',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload a reference image.',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling 2.6 Pro',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Kling 2.6 Pro',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Tools on WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling 2.6 Pro Now',
        ctaDescription: 'Start creating audio-visual synchronized AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',

        },
    da: { // Danish (copied from English)
        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI Video Generator - Audio-Visual Synchronization | WeryAI',
        pageDescription: 'Kling 2.6 Pro is Kuaishou\'s revolutionary AI video generation model, pioneering audio-visual synchronization generation, supporting 1080p HD video, bilingual voice (Chinese/English), and character consistency control. Experience Kling 2.6 Pro for free on WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, AI video generation, audio-visual sync, Kuaishou AI, video generator, AI voiceover, 1080p video, WeryAI',

        // Generator section
        generatorTitle: 'Kling 2.6 Pro Video Generator',
        generatorDescription: 'WeryAI har nu integreret modellen Kling 2.6 Pro i dybden, Kling 2.6 Pro is a revolutionary all-in-one AI video generation model launched by Kling AI under Kuaishou. As the professional flagship of version 2.6, it not only inherits the excellent image quality of previous generations but also pioneers "audio-visual synchronization generation" capability, automatically synthesizing precisely matched dialogue, sound effects, and ambient sounds while generating 1080p HD video. This breakthrough technology allows creators to obtain complete audiovisual works without post-production dubbing, greatly improving efficiency from concept to finished product. Come experience the magic of Kling 2.6 Pro\'s audio-visual synchronization on WeryAI for free!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling 2.6 Pro Core Features',

        // Features
        feature1Title: 'Native Audio-Visual Synchronization',
        feature1Description: 'Kling 2.6 Pro breaks the traditional boundary of separate video and audio generation. It can simultaneously generate precisely synchronized sound effects (such as footsteps, collision sounds) and natural human dialogue in a single inference based on the visual content, ensuring "what you see is what you hear".',
        feature2Title: 'Bilingual Voice Support (Chinese/English)',
        feature2Description: 'The model has built-in high-quality Chinese and English voice engines. Users only need to specify dialogue in the prompt to generate character conversations with synchronized lip movements, supporting various emotional tones, perfect for creating narrative short films or marketing advertisements.',
        feature3Title: '1080p Cinematic Quality & Lighting',
        feature3Description: 'Output resolution defaults to 1080p with extremely high visual fidelity. The model\'s understanding of light reflection, material textures (such as skin, metal, water surfaces) has reached new heights, with fine details and no noise.',
        feature4Title: 'Elements Character Consistency Control',
        feature4Description: 'Through the "Elements" feature, users can upload reference images to fix the main character\'s appearance in the video. Even in complex camera movements or long shots, the character\'s facial features and clothing details remain highly consistent, no more "face swapping".',
        feature5Title: 'Long Video Extension & Coherence',
        feature5Description: 'Supports basic 10-second generation, and can extend video duration multiple times through the "Extend" feature (up to several minutes), while maintaining smooth motion and logical coherence, suitable for creating long-shot narrative content.',

        // How to use section
        howToUseTitle: 'How to Use Kling 2.6 Pro on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling 2.6 Pro model in the AI video tools.',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload a reference image.',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling 2.6 Pro',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Kling 2.6 Pro',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Tools on WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling 2.6 Pro Now',
        ctaDescription: 'Start creating audio-visual synchronized AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',

        },
    no: { // Norwegian (copied from English)
        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI Video Generator - Audio-Visual Synchronization | WeryAI',
        pageDescription: 'Kling 2.6 Pro is Kuaishou\'s revolutionary AI video generation model, pioneering audio-visual synchronization generation, supporting 1080p HD video, bilingual voice (Chinese/English), and character consistency control. Experience Kling 2.6 Pro for free on WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, AI video generation, audio-visual sync, Kuaishou AI, video generator, AI voiceover, 1080p video, WeryAI',

        // Generator section
        generatorTitle: 'Kling 2.6 Pro Video Generator',
        generatorDescription: 'WeryAI har nå integrert modellen Kling 2.6 Pro i dybden, Kling 2.6 Pro is a revolutionary all-in-one AI video generation model launched by Kling AI under Kuaishou. As the professional flagship of version 2.6, it not only inherits the excellent image quality of previous generations but also pioneers "audio-visual synchronization generation" capability, automatically synthesizing precisely matched dialogue, sound effects, and ambient sounds while generating 1080p HD video. This breakthrough technology allows creators to obtain complete audiovisual works without post-production dubbing, greatly improving efficiency from concept to finished product. Come experience the magic of Kling 2.6 Pro\'s audio-visual synchronization on WeryAI for free!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling 2.6 Pro Core Features',

        // Features
        feature1Title: 'Native Audio-Visual Synchronization',
        feature1Description: 'Kling 2.6 Pro breaks the traditional boundary of separate video and audio generation. It can simultaneously generate precisely synchronized sound effects (such as footsteps, collision sounds) and natural human dialogue in a single inference based on the visual content, ensuring "what you see is what you hear".',
        feature2Title: 'Bilingual Voice Support (Chinese/English)',
        feature2Description: 'The model has built-in high-quality Chinese and English voice engines. Users only need to specify dialogue in the prompt to generate character conversations with synchronized lip movements, supporting various emotional tones, perfect for creating narrative short films or marketing advertisements.',
        feature3Title: '1080p Cinematic Quality & Lighting',
        feature3Description: 'Output resolution defaults to 1080p with extremely high visual fidelity. The model\'s understanding of light reflection, material textures (such as skin, metal, water surfaces) has reached new heights, with fine details and no noise.',
        feature4Title: 'Elements Character Consistency Control',
        feature4Description: 'Through the "Elements" feature, users can upload reference images to fix the main character\'s appearance in the video. Even in complex camera movements or long shots, the character\'s facial features and clothing details remain highly consistent, no more "face swapping".',
        feature5Title: 'Long Video Extension & Coherence',
        feature5Description: 'Supports basic 10-second generation, and can extend video duration multiple times through the "Extend" feature (up to several minutes), while maintaining smooth motion and logical coherence, suitable for creating long-shot narrative content.',

        // How to use section
        howToUseTitle: 'How to Use Kling 2.6 Pro on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling 2.6 Pro model in the AI video tools.',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload a reference image.',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling 2.6 Pro',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Kling 2.6 Pro',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Tools on WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling 2.6 Pro Now',
        ctaDescription: 'Start creating audio-visual synchronized AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',

        },
    nl: { // Dutch (copied from English)
        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI Video Generator - Audio-Visual Synchronization | WeryAI',
        pageDescription: 'Kling 2.6 Pro is Kuaishou\'s revolutionary AI video generation model, pioneering audio-visual synchronization generation, supporting 1080p HD video, bilingual voice (Chinese/English), and character consistency control. Experience Kling 2.6 Pro for free on WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, AI video generation, audio-visual sync, Kuaishou AI, video generator, AI voiceover, 1080p video, WeryAI',

        // Generator section
        generatorTitle: 'Kling 2.6 Pro Video Generator',
        generatorDescription: 'WeryAI heeft het model Kling 2.6 Pro nu diep geïntegreerd, Kling 2.6 Pro is a revolutionary all-in-one AI video generation model launched by Kling AI under Kuaishou. As the professional flagship of version 2.6, it not only inherits the excellent image quality of previous generations but also pioneers "audio-visual synchronization generation" capability, automatically synthesizing precisely matched dialogue, sound effects, and ambient sounds while generating 1080p HD video. This breakthrough technology allows creators to obtain complete audiovisual works without post-production dubbing, greatly improving efficiency from concept to finished product. Come experience the magic of Kling 2.6 Pro\'s audio-visual synchronization on WeryAI for free!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling 2.6 Pro Core Features',

        // Features
        feature1Title: 'Native Audio-Visual Synchronization',
        feature1Description: 'Kling 2.6 Pro breaks the traditional boundary of separate video and audio generation. It can simultaneously generate precisely synchronized sound effects (such as footsteps, collision sounds) and natural human dialogue in a single inference based on the visual content, ensuring "what you see is what you hear".',
        feature2Title: 'Bilingual Voice Support (Chinese/English)',
        feature2Description: 'The model has built-in high-quality Chinese and English voice engines. Users only need to specify dialogue in the prompt to generate character conversations with synchronized lip movements, supporting various emotional tones, perfect for creating narrative short films or marketing advertisements.',
        feature3Title: '1080p Cinematic Quality & Lighting',
        feature3Description: 'Output resolution defaults to 1080p with extremely high visual fidelity. The model\'s understanding of light reflection, material textures (such as skin, metal, water surfaces) has reached new heights, with fine details and no noise.',
        feature4Title: 'Elements Character Consistency Control',
        feature4Description: 'Through the "Elements" feature, users can upload reference images to fix the main character\'s appearance in the video. Even in complex camera movements or long shots, the character\'s facial features and clothing details remain highly consistent, no more "face swapping".',
        feature5Title: 'Long Video Extension & Coherence',
        feature5Description: 'Supports basic 10-second generation, and can extend video duration multiple times through the "Extend" feature (up to several minutes), while maintaining smooth motion and logical coherence, suitable for creating long-shot narrative content.',

        // How to use section
        howToUseTitle: 'How to Use Kling 2.6 Pro on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling 2.6 Pro model in the AI video tools.',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload a reference image.',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling 2.6 Pro',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Kling 2.6 Pro',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Tools on WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling 2.6 Pro Now',
        ctaDescription: 'Start creating audio-visual synchronized AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',

        },
    id: { // Indonesian (copied from English)
        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI Video Generator - Audio-Visual Synchronization | WeryAI',
        pageDescription: 'Kling 2.6 Pro is Kuaishou\'s revolutionary AI video generation model, pioneering audio-visual synchronization generation, supporting 1080p HD video, bilingual voice (Chinese/English), and character consistency control. Experience Kling 2.6 Pro for free on WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, AI video generation, audio-visual sync, Kuaishou AI, video generator, AI voiceover, 1080p video, WeryAI',

        // Generator section
        generatorTitle: 'Kling 2.6 Pro Video Generator',
        generatorDescription: 'WeryAI kini telah mengintegrasikan model Kling 2.6 Pro secara mendalam, Kling 2.6 Pro is a revolutionary all-in-one AI video generation model launched by Kling AI under Kuaishou. As the professional flagship of version 2.6, it not only inherits the excellent image quality of previous generations but also pioneers "audio-visual synchronization generation" capability, automatically synthesizing precisely matched dialogue, sound effects, and ambient sounds while generating 1080p HD video. This breakthrough technology allows creators to obtain complete audiovisual works without post-production dubbing, greatly improving efficiency from concept to finished product. Come experience the magic of Kling 2.6 Pro\'s audio-visual synchronization on WeryAI for free!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling 2.6 Pro Core Features',

        // Features
        feature1Title: 'Native Audio-Visual Synchronization',
        feature1Description: 'Kling 2.6 Pro breaks the traditional boundary of separate video and audio generation. It can simultaneously generate precisely synchronized sound effects (such as footsteps, collision sounds) and natural human dialogue in a single inference based on the visual content, ensuring "what you see is what you hear".',
        feature2Title: 'Bilingual Voice Support (Chinese/English)',
        feature2Description: 'The model has built-in high-quality Chinese and English voice engines. Users only need to specify dialogue in the prompt to generate character conversations with synchronized lip movements, supporting various emotional tones, perfect for creating narrative short films or marketing advertisements.',
        feature3Title: '1080p Cinematic Quality & Lighting',
        feature3Description: 'Output resolution defaults to 1080p with extremely high visual fidelity. The model\'s understanding of light reflection, material textures (such as skin, metal, water surfaces) has reached new heights, with fine details and no noise.',
        feature4Title: 'Elements Character Consistency Control',
        feature4Description: 'Through the "Elements" feature, users can upload reference images to fix the main character\'s appearance in the video. Even in complex camera movements or long shots, the character\'s facial features and clothing details remain highly consistent, no more "face swapping".',
        feature5Title: 'Long Video Extension & Coherence',
        feature5Description: 'Supports basic 10-second generation, and can extend video duration multiple times through the "Extend" feature (up to several minutes), while maintaining smooth motion and logical coherence, suitable for creating long-shot narrative content.',

        // How to use section
        howToUseTitle: 'How to Use Kling 2.6 Pro on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling 2.6 Pro model in the AI video tools.',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload a reference image.',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling 2.6 Pro',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Kling 2.6 Pro',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Tools on WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling 2.6 Pro Now',
        ctaDescription: 'Start creating audio-visual synchronized AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',

        },
    tr: { // Turkish (copied from English)
        // SEO Meta
        pageTitle: 'Kling 2.6 Pro AI Video Generator - Audio-Visual Synchronization | WeryAI',
        pageDescription: 'Kling 2.6 Pro is Kuaishou\'s revolutionary AI video generation model, pioneering audio-visual synchronization generation, supporting 1080p HD video, bilingual voice (Chinese/English), and character consistency control. Experience Kling 2.6 Pro for free on WeryAI.',
        pageKeywords: 'Kling 2.6 Pro, AI video generation, audio-visual sync, Kuaishou AI, video generator, AI voiceover, 1080p video, WeryAI',

        // Generator section
        generatorTitle: 'Kling 2.6 Pro Video Generator',
        generatorDescription: 'WeryAI artık Kling 2.6 Pro modelini derinlemesine entegre ediyor, Kling 2.6 Pro is a revolutionary all-in-one AI video generation model launched by Kling AI under Kuaishou. As the professional flagship of version 2.6, it not only inherits the excellent image quality of previous generations but also pioneers "audio-visual synchronization generation" capability, automatically synthesizing precisely matched dialogue, sound effects, and ambient sounds while generating 1080p HD video. This breakthrough technology allows creators to obtain complete audiovisual works without post-production dubbing, greatly improving efficiency from concept to finished product. Come experience the magic of Kling 2.6 Pro\'s audio-visual synchronization on WeryAI for free!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Kling 2.6 Pro Core Features',

        // Features
        feature1Title: 'Native Audio-Visual Synchronization',
        feature1Description: 'Kling 2.6 Pro breaks the traditional boundary of separate video and audio generation. It can simultaneously generate precisely synchronized sound effects (such as footsteps, collision sounds) and natural human dialogue in a single inference based on the visual content, ensuring "what you see is what you hear".',
        feature2Title: 'Bilingual Voice Support (Chinese/English)',
        feature2Description: 'The model has built-in high-quality Chinese and English voice engines. Users only need to specify dialogue in the prompt to generate character conversations with synchronized lip movements, supporting various emotional tones, perfect for creating narrative short films or marketing advertisements.',
        feature3Title: '1080p Cinematic Quality & Lighting',
        feature3Description: 'Output resolution defaults to 1080p with extremely high visual fidelity. The model\'s understanding of light reflection, material textures (such as skin, metal, water surfaces) has reached new heights, with fine details and no noise.',
        feature4Title: 'Elements Character Consistency Control',
        feature4Description: 'Through the "Elements" feature, users can upload reference images to fix the main character\'s appearance in the video. Even in complex camera movements or long shots, the character\'s facial features and clothing details remain highly consistent, no more "face swapping".',
        feature5Title: 'Long Video Extension & Coherence',
        feature5Description: 'Supports basic 10-second generation, and can extend video duration multiple times through the "Extend" feature (up to several minutes), while maintaining smooth motion and logical coherence, suitable for creating long-shot narrative content.',

        // How to use section
        howToUseTitle: 'How to Use Kling 2.6 Pro on WeryAI',
        step1Title: 'Select Model',
        step1Description: 'Select the Kling 2.6 Pro model in the AI video tools.',
        step2Title: 'Input Content',
        step2Description: 'Enter a prompt or upload a reference image.',
        step3Title: 'Generate Video',
        step3Description: 'Click the generate button, wait, and download your video.',

        // YouTube videos section
        youtubeTitle: 'Exciting Video Introductions About Kling 2.6 Pro',

        // X Posts section
        xPostsTitle: 'Trending X Posts about Kling 2.6 Pro',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Tools on WeryAI',
        klingO1Title: 'Kling O1 (Kling Omni)',
        lumaTitle: 'Luma Dream Machine',
        runwayTitle: 'Runway Gen-3 Alpha',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Experience Kling 2.6 Pro Now',
        ctaDescription: 'Start creating audio-visual synchronized AI videos for free on WeryAI',
        ctaButton: 'Start Generating Videos',
        ctaDisclaimer: 'No credit card required, register to use',

    },
}
